// import { Entity, EntityAspect, EntityManager, EntityType } from 'breeze-client';
// import _ from 'lodash';
// import moment from 'moment';
// import { GenesisUnitOfWork } from './genesis-unit-of-work';
// import { AnyTxtRecord } from 'dns';

import { BaseEntity } from "../base-entity";
import { Customer } from "../model/entity-model";

export type Guid = string;

export class Entities {
    static lookups: any;
    // static registerEntityTypes(manager: EntityManager) {
    //     manager.metadataStore.registerEntityTypeCtor('Part', Part);
    //     manager.metadataStore.registerEntityTypeCtor('PartPurchase', PartPurchase);
    //     manager.metadataStore.registerEntityTypeCtor('PartOption', PartOption);
    //     manager.metadataStore.registerEntityTypeCtor('PartLink', PartLink);
    //     manager.metadataStore.registerEntityTypeCtor('BuildAssembly', BuildAssembly);
    //     manager.metadataStore.registerEntityTypeCtor('BuildAssemblyDetail', BuildAssemblyDetail);
    //     manager.metadataStore.registerEntityTypeCtor('Order', Order);
    //     manager.metadataStore.registerEntityTypeCtor('OrderLine', OrderLine);
    //     manager.metadataStore.registerEntityTypeCtor('OrderLineDeatil', OrderLineDetail);
    //     manager.metadataStore.registerEntityTypeCtor('OrderLineDetailNote', OrderLineDetailNote);
    //     manager.metadataStore.registerEntityTypeCtor('CustomerLocation', CustomerLocation);
    //     manager.metadataStore.registerEntityTypeCtor('Customer', Customer);
    //     manager.metadataStore.registerEntityTypeCtor('PartType', PartType);
    //     manager.metadataStore.registerEntityTypeCtor('PartPartType', PartPartType);
    //     manager.metadataStore.registerEntityTypeCtor('PackingSlip', PackingSlip);
    //     manager.metadataStore.registerEntityTypeCtor('PurchaseOrder', PurchaseOrder);
    //     manager.metadataStore.registerEntityTypeCtor('PurchaseOrderLine', PurchaseOrderLine);
    //     manager.metadataStore.registerEntityTypeCtor('PurchaseOrderLineReceiving', PurchaseOrderLineReceiving);
    //     manager.metadataStore.registerEntityTypeCtor('EmailAddress', EmailAddress);
    //     manager.metadataStore.registerEntityTypeCtor('EmailMessage', EmailMessage);
    //     manager.metadataStore.registerEntityTypeCtor('AuditLog', AuditLog);
    //     manager.metadataStore.registerEntityTypeCtor('User', User);
    //     manager.metadataStore.registerEntityTypeCtor('EventLog', EventLog);
    //     manager.metadataStore.registerEntityTypeCtor('AssemblySchedule', AssemblySchedule);
    //     manager.metadataStore.registerEntityTypeCtor('Setting', Setting);
    //     manager.metadataStore.registerEntityTypeCtor('SalesRep', SalesRep);
    //     manager.metadataStore.registerEntityTypeCtor('Confirmation', Confirmation);
    //     manager.metadataStore.registerEntityTypeCtor('ConfirmationMessage', ConfirmationMessage);
    //     manager.metadataStore.registerEntityTypeCtor('ConfirmationType', ConfirmationType);
    //     manager.metadataStore.registerEntityTypeCtor('ConfirmationPaymentMethod', ConfirmationPaymentMethod);
    // }
}

// class BaseEntity implements Entity {
//     entityAspect: EntityAspect;
//     entityType: EntityType;
// }

// class BaseGuidEntity extends BaseEntity {
//     id: Guid;
// }

// class BaseIntEntity extends BaseEntity {
//     id: number;
// }

// export class User extends BaseIntEntity {
//     jwtToken?: string;
//     userName: string;
//     userRoles: UserRole[];

//     get displayRoles() {
//         let roles = null;
//         if (!!this.userRoles) {
//             const userRoles = _(this.userRoles).orderBy('role.name');
//             userRoles.forEach((x) => {
//                 if (!!roles) roles += `  --  ${x.role.name}`;
//                 else roles = x.role.name;
//             });
//         }
//         return roles;
//     }
// }

// export class UserRole extends BaseIntEntity {
//     userId: number;
//     user: User;
//     roleId: number;
//     role: Role;
// }

// export class EventLog extends BaseIntEntity {
//     message: string;
//     dateTime: Date;
//     level: string;
// }

// export class Role extends BaseIntEntity {
//     name: string;
//     userRoles: UserRole[];
// }

// export class Part extends BaseIntEntity {
//     partNumber: any;
//     description: any;
//     reOrderMinimum: number;
//     reOrderQuantity: number;
//     mfgPartNumber: number;
//     mfgDescription: number;
//     cost: number;
//     price: number;
//     retailPrice: number;
//     preferredVendor: any;
//     unitOfMeasure: any;
//     deleted: Date;
//     partLinks: PartLink[];
//     inStock: number;
//     category: any;
//     created: Date;
//     trackInventory: boolean;
//     vINPrefix: any;
//     partPartTypes: PartPartType[];
//     note: any;
//     processing: number;
//     purchaseOrderLines: PurchaseOrderLine[];
//     calculatedCost: number;
//     parentPartId: number;
//     parentPart: Part;
//     frameId: number;
//     frame: Part;
//     childrenParts: Part[];
//     isAssembly: boolean;

//     get displayName() {
//         if (!!this.partNumber && !!this.description) return `${this.partNumber} - ${this.description}`;
//         else return this.partNumber;
//     }

//     get mfgDisplayName() {
//         if (!!this.mfgPartNumber && !!this.mfgDescription) return `${this.mfgPartNumber} - ${this.mfgDescription}`;
//         else return this.mfgPartNumber;
//     }

//     get partTypes() {
//         let partTypes = '';
//         _(this.partPartTypes)
//             .sortBy('partType.name')
//             .forEach((a) => {
//                 partTypes = `${partTypes}, ${a.partType.name}`;
//             });
//         if (partTypes !== '') partTypes = partTypes.substring(2);
//         return partTypes;
//     }

//     // described as Quantity - Received
//     get onOrder() {
//         let qty = 0;
//         if (!!this.purchaseOrderLines && this.purchaseOrderLines.length > 0) {
//             this.purchaseOrderLines.forEach((line) => {
//                 if (!!line.purchaseOrder && !line.purchaseOrder.deleted && line.purchaseOrder.statusId !== PurchaseOrder.Statuses.Complete)
//                     qty += line.quantity - line.quantityReceived;
//             });
//         }
//         return qty;
//     }
//     get onBackOrder() {
//         let qty = 0;
//         if (!!this.purchaseOrderLines && this.purchaseOrderLines.length > 0) {
//             this.purchaseOrderLines.forEach((line) => {
//                 if (!!line.purchaseOrder && !line.purchaseOrder.deleted && line.purchaseOrder.statusId !== PurchaseOrder.Statuses.Complete) qty += line.quantityBackOrdered;
//             });
//         }
//         return qty;
//     }

//     get tier2() {
//         return this.getTierPrice(2);
//     }
//     get tier3() {
//         return this.getTierPrice(3);
//     }
//     get tier4() {
//         return this.getTierPrice(4);
//     }
//     getTierPrice(id: number) {
//         const tier = _.find(Entities.lookups.pricingTiers, { id: id }) as any;
//         if (!!tier) {
//             return Math.floor(this.price * (1 - tier.percentage));
//         } else return 0;
//     }
// }

// export class PartPurchase extends BaseIntEntity {
//     partId: number;
//     date: Date;
//     quantity: number;
//     price: number;
//     reason: string;
//     inStock: number;
//     allocated: number;
//     projectedInventory: number;
//     createdBy: string;

//     get enteredAmount() {
//         return this.inStock !== 0 ? this.inStock + this.quantity : 0;
//     }
// }

// export class PartOption extends BaseIntEntity {
//     part: Part;
//     partId: number;
//     optionPart: Part;
//     optionPartId: number;
//     displayOrder: number;
//     deleted: Date;
// }

// export class PartLink extends BaseIntEntity {
//     partId: any;
//     part: Part;
//     subPartId: any;
//     subPart: Part;
//     quantity: number;
//     createdBy: any;
//     created: Date;
//     deletedBy: any;
//     deleted: Date;
// }

// export class PartType extends BaseIntEntity {
//     static Types = {
//         RawGood: 1,
//         InProcess: 2,
//         Invenotry: 3,
//         Finished: 4,
//         Option: 5,
//         Replacement: 6,
//         Trailer: 7,
//     };
//     name: string;
//     displayOrder: number;
//     note: string;
//     deleted: Date;
//     partPartTypes: PartPartType[];
// }

// export class PartPartType extends BaseIntEntity {
//     static Types = {
//         Raw: 1,
//         InProcess: 2,
//         InventoryPart: 3,
//         FinishedProduct: 4,
//         OptionUpgrade: 5,
//         Replacement: 6,
//         Trailer: 7,
//     };
//     partId: number;
//     part: Part;
//     partTypeId: number;
//     partType: PartType;
// }

// export class BuildAssembly extends BaseIntEntity {
//     static Statuses = {
//         New: 1,
//         Submitted: 2,
//         Complete: 3,
//         Error: 4,
//     };

//     buildNumber: number;
//     buildDate: Date;
//     statusId: number;
//     notes: string;
//     createDate: Date;
//     createdBy: string;
//     deleted: Date;
//     deletedBy: string;
//     details: BuildAssemblyDetail[];
//     createPO: boolean;
//     vendorId: number;
//     vendor: Vendor;
//     purchaseOrderId: number;
//     PurchaseOrder: PurchaseOrder;
//     shipToId: number;
// }

// export class BuildAssemblyDetail extends BaseIntEntity {
//     buildAssemblyId: number;
//     buildAssembly: BuildAssembly;
//     lineNumber: number;
//     quantity: number;
//     partId: number;
//     part: Part;
//     partNumber: string;
//     description: string;
//     builtBy: string;
//     notes: string;
//     status: number;
//     partCount: number;
//     created: Date;
//     deleted: Date;
// }

// export class Order extends BaseIntEntity {
//     static ACHDiscountPercentage = 0.02;

//     static DeliveryOptions = {
//         Genesis: 1,
//         CPU: 2,
//         UPS: 3,
//         TBD: 4,
//         DPU: 5,
//     };

//     static Statuses = {
//         New: 1,
//         InProcess: 2,
//         Complete: 3,
//         Paid: 4,
//         Canceled: 5,
//         WaitingOnConfirmation: 6,
//     };

//     static Types = {
//         SalesOrder: 1,
//         Warranty: 2,
//     };

//     invoiceNumber: number;
//     type: number;
//     vIN: any;
//     customerId: number;
//     customer: Customer;
//     dealerId: number;
//     dealer: Dealer;
//     dueDate: Date;
//     statusId: number;
//     status: OrderStatus;
//     orderType: any;
//     shipCompanyName: any; //this field does not exist in the database
//     shipToContactName: any;
//     shipToLocation: any;
//     shipToAddress1: any;
//     shipToAddress2: any;
//     shipToCity: any;
//     shipToState: any;
//     shipToZip: any;
//     shipToCountry: any;
//     shipToPhone: any;
//     shipToEmail: any;
//     trackingNumber: any;
//     tax: number;
//     freight: number;
//     total: number;
//     balance: number;
//     deliveryOptionString: any;
//     paymentMethod: any;
//     note: any;
//     createdById: number;
//     createDate: Date;
//     orderLines: OrderLine[];
//     pONumber: any;
//     deliverer: any;
//     orderGUID: Guid;
//     createdTimestamp: Date;
//     printPricing: boolean;
//     uPSFreight: number;
//     shipAddressId: number;
//     deliveryOptionId: number;
//     confirmations: Confirmation[];
//     currentYTDSales: number;
//     pricingTierId: number;
//     pricingTier: PricingTier;
//     discountName: string;
//     discountPercentage: number;
//     achPayments: OrderAchPayment[];
//     achTotal: number;

//     get statusName() {
//         return this.status && this.status.name;
//     }

//     get subTotal() {
//         let subTotal = 0;
//         if (!!this.orderLines) {
//             this.orderLines.forEach((line) => {
//                 if (!line.parentLineId || line.isOption) {
//                     // do not calculate price for sub-lines which are components for the assembly
//                     subTotal += line.quantity * line.price;
//                 }
//             });
//         }
//         return subTotal;
//     }
//     get originalTotal() {
//         let total = 0;
//         if (!!this.orderLines) {
//             this.orderLines.forEach((line) => {
//                 if (!line.deleted) total += line.quantity * line.originalPrice;
//             });
//         }
//         return total;
//     }

//     get discountAmount() {
//         return this.originalTotal - this.subTotal;
//     }

//     // get achDiscountAmount() {
//     //     let subTotal = 0;
//     //     if (!!this.orderLines) {
//     //         this.orderLines.forEach((line) => {
//     //             subTotal += line.quantity >= 0 ? Math.ceil(line.quantity * line.price * (1 - Order.ACHDiscountPercentage)) :  Math.floor(line.quantity * line.price * (1 - Order.ACHDiscountPercentage));
//     //             console.log(`${line.price} - ${subTotal}`);
//     //         });
//     //     }
//     //     return subTotal;
//     // }

//     get achDiscountAmount() {
//         let total = 0;
//         if (!!this.orderLines) {
//             this.orderLines.forEach((line) => {
//                 total += line.quantity * line.achLineAmount;
//             });
//         }
//         return total;
//     }

//     get achDiscountAmountDisplay() {
//         let total = 0;
//         if (this.achPayments.length > 0) return this.achPayments[0].amount;
//         else if (!!this.orderLines) {
//             this.orderLines.forEach((line) => {
//                 total += line.quantity * line.achLineAmount;
//             });
//         }
//         return total;
//     }

//     get invoiceNumberDisplay(): string {
//         if (this.type === Order.Types.Warranty) return `W-${this.invoiceNumber}`;
//         else return this.invoiceNumber.toString();
//     }

//     static getNextLineNumber(lines: any[]) {
//         if (lines.length === 0) return 1;

//         let lineNumber: any;
//         lineNumber = _.maxBy(lines, 'lineNumber').lineNumber + 1;
//         return lineNumber;
//     }

//     getNextLineNumber() {
//         return Order.getNextLineNumber(this.orderLines);
//     }
//     get shippingAddressDisplay() {
//         return `${!!this.shipToLocation ? this.shipToLocation + ' - ' : ''}${this.shipToAddress1}${this.shipToAddress2 ? ' ' + this.shipToAddress2 + ' ' : ''} ${
//             this.shipToCity
//         }, ${this.shipToState} ${this.shipToZip}  ${this.shipToCountry}`;
//     }

//     get allowFreightEntry() {
//         let allow = false;
//         if (!!this.deliveryOptionId) {
//             if (this.deliveryOptionId === Order.DeliveryOptions.UPS) allow = true;
//         }
//         return allow;
//     }

//     get freightDisplay() {
//         let freight = 'TBD';
//         if (!!this.deliveryOptionId) {
//             if (this.deliveryOptionId === Order.DeliveryOptions.UPS) freight = this.freight.toString();
//             else if (this.deliveryOptionId === Order.DeliveryOptions.CPU || this.deliveryOptionId === Order.DeliveryOptions.DPU) freight = '0.00';
//         }
//         return freight;
//     }
// }

// export class PricingTier extends BaseIntEntity {
//     name: string;
//     percentage: number;
//     minimumAmount: number;
//     maximumAmount: number;
//     displayOrder: number;
//     deleted: Date;
// }

// export class OrderAchPayment extends BaseIntEntity {
//     orderId: number;
//     order: Order;
//     transactionDate: Date;
//     transactionNumber: string;
//     amount: number;
//     notes: string;
//     created: Date;
//     createdBy: string;
// }
// export class OrderStatus extends BaseIntEntity {
//     name: any;
// }

// export class OrderLine extends BaseIntEntity {
//     orderId: number;
//     order: Order;
//     lineNumber: number;
//     partId: number;
//     part: Part;
//     partNumber: any;
//     description: any;
//     quantity: number;
//     extendedQuantity: number;
//     cost: number;
//     price: number;
//     originalPrice: number;
//     parentLineId: number;
//     parentLine: OrderLine;
//     children: OrderLine[];
//     isOption: boolean;
//     isReplacement: boolean;
//     vins: Vin[];
//     category: any;
//     orderLineDetails: OrderLineDetail[];
//     deleted: Date;
//     paidAch: Date;

//     _displayOrder: number;
//     get displayOrder() {
//         if (!this._displayOrder) this._displayOrder = 10000 * (!!this.parentLine ? this.parentLine.lineNumber : this.lineNumber) + this.lineNumber;
//         return this._displayOrder;
//     }

//     get vinDisplay() {
//         // if (!this.orderLineDetails) return;
//         let vinName = '';
//         if (!!this.orderLineDetails && this.orderLineDetails.length > 0 && !this.isOption && !this.isReplacement && !!this.partId) {
//             this.orderLineDetails.forEach((vin) => {
//                 if (!!vin.vIN) vinName = `${vinName}${vin.vIN}; `;
//             });
//         }
//         return vinName;
//     }

//     get orderLineDetailStatuses() {
//         if (!this.orderLineDetails) return;

//         const statusArray = [];
//         this.orderLineDetails.forEach((detail) => {
//             if (!!detail.status) {
//                 const findStatus = _.find(statusArray, { name: detail.status.name }) as any;
//                 if (!findStatus) {
//                     statusArray.push({ count: 1, name: detail.status.name });
//                 } else {
//                     findStatus.count = findStatus.count + 1;
//                 }
//             }
//         });

//         let statusString = '';
//         statusArray.forEach((status) => {
//             statusString += `${status['name']} [${status['count']}]; `;
//         });
//         return statusString;
//     }

//     delete(recursive = true) {
//         if (recursive) {
//             while (this.children.length > 0) {
//                 this.children[0].delete(recursive);
//             }
//         }
//         this.entityAspect.setDeleted();
//     }

//     get achLineAmount() {
//         return Math.floor(this.price * (1 - Order.ACHDiscountPercentage));
//     }

//     get lineTotal() {
//         return !!this.paidAch ? this.quantity * this.achLineAmount : this.quantity * this.price;
//     }

//     get linePrice() {
//         return !!this.paidAch ? this.achLineAmount : this.price;

//     }

//     get partNumberWithPrice () {
//         return  `${this.partNumber} ${this.linePrice.toLocaleString('en-US', {
//             style: 'currency',
//             currency: 'USD',
//         })}`
//     }
// }

// export class OrderLineDetail extends BaseIntEntity {
//     static Statuses = {
//         InProcess: 1,
//         Built: 2,
//         Stacked: 3,
//         Complete: 4,
//         WaitingForPickup: 5, // not used anymore
//         ReadyDeliverPickup: 6,
//         WaitingOn: 8,
//         DeliveredPicked: 9,
//         New: 10,
//         Winter: 11,
//         PackSlipCreated: 12,
//     };
//     orderLineId: number;
//     orderLine: OrderLine;
//     statusId: number;
//     status: OrderLineStatus;
//     vIN: any;
//     options: any;
//     note: any;
//     notes: any[];
//     quantity: any;
//     isOption: boolean;
//     isReplacement: boolean;
//     isMisc: boolean;
//     created: Date;
//     deleted: Date;
//     parentLineId: number;
//     parentLine: OrderLineDetail;
//     packingSlipId: number;
//     packingSlip: PackingSlip;
//     built: Date;
//     processed: number;
//     hotOrder: boolean;
//     dueDate: Date;

//     get vinEndingDisplay() {
//         return `${!!this.vIN ? this.vIN.substring(this.vIN.length - 7) : ''}`;
//     }
// }

// export class OrderLineDetailNote extends BaseIntEntity {
//     orderLineDetailId: number;
//     orderLineDetail: OrderLineDetail;
//     note: any;
//     createdById: number;
//     createDate: Date;
//     manualNote: boolean;

//     get dateDisplay() {
//         return moment(this.createDate).format('MM/DD/YYYY hh:mm:ssA');
//     }
// }

// export class OrderLineStatus extends BaseIntEntity {
//     static OrderLineStatusOptions = {
//         InProcess: 1,
//         Built: 2,
//         Stacked: 3,
//         Complete: 4,
//         ReadToDeliverPickup: 6,
//         WaitingOn: 8,
//         DeliveredPickedUp: 9,
//         New: 10,
//         Winter: 11,
//         PackSlipCreated: 12,
//     };

//     name: any;
//     displayOrder: number;
//     countAsWIP: boolean;
// }

// export class Vin extends BaseIntEntity {
//     orderLineId: number;
//     orderLine: OrderLine;
//     vIN: any;
// }

// export class Customer extends BaseIntEntity {
//     type: any;
//     firstName: any;
//     lastName: any;
//     companyName: any;
//     contactName: any;
//     billAddress1: any;
//     billAddress2: any;
//     billCity: any;
//     billState: any;
//     billZip: any;
//     billCountry: any;
//     billCountryOther: any;
//     shipToAddress1: any;
//     shipToAddress2: any;
//     shipToCity: any;
//     shipToState: any;
//     shipToZip: any;
//     shipToCountry: any;
//     email: any;
//     phone1: any;
//     phone2: any;
//     created: Date;
//     createdBy: any;
//     country: any;

//     get displayName() {
//         if (!!this.companyName && !!this.contactName) return `${this.companyName} - ${this.contactName}`;
//         if (!!this.companyName) return this.companyName;
//         if (!!this.contactName) return this.contactName;
//     }

//     // get customerName() {
//     //     if (this.type === 'Business') {
//     //         return `${this.businessName || ''}${this.firstName ? ' - ' + this.firstName : ''}${this.lastName ? ' ' + this.lastName : ''}`;
//     //     } else {
//     //         return `${this.firstName || ''} ${this.lastName || ''}`;
//     //     }
//     // }
//     // get contactName() {
//     //     return `${this.firstName || ''} ${this.lastName || ''}`;
//     // }
// }

export class CustomerLocation extends BaseEntity {
    customerId: number;
    customer: Customer;
    location: any;
    address1: any;
    address2: any;
    city: any;
    state: any;
    zip: any;

    get locationAddress() {
        return `${this.address1 || ''} ${this.address2 ? this.address2 + ' ' : ''}${this.city || ''} ${this.state || ''} ${this.zip || ''}`;
    }
}

// export class Dealer extends BaseIntEntity {
//     static DealerOptions = {
//         Miscellaneous: 285
//     }

//     companyName: any;
//     contactName: any;
//     billAddress1: any;
//     billAddress2: any;
//     billCity: any;
//     billState: any;
//     billZip: any;
//     billCountry: any;
//     billCountryOther: any;
//     email: any;
//     phone1: any;
//     phone2: any;
//     fax: any;
//     shipSameAsBilling: boolean;
//     shippingNote: any;
//     terms: any;
//     rep: any;
//     resaleNumber: any;
//     accountNumber: any;
//     deleted: Date;
//     freight: number;
//     colorCode: any;
//     salesOrderPricingVisible: boolean;
//     aPEmail: string;
//     notes: string;
//     pastDue: Date;
//     loadedMiles: number;
//     salesRepId: number;
//     salesRep: SalesRep;
//     inactive: Date;

//     get displayName() {
//         if (!!this.companyName && !!this.contactName) return `${this.companyName} - ${this.contactName}`;
//         if (!!this.companyName) return this.companyName;
//         if (!!this.contactName) return this.contactName;
//     }

//     get inactiveBool() {
//         return !!this.inactive;
//     }
// }

// export class ShipAddress extends BaseIntEntity {
//     dealerId: number;
//     location: any;
//     address1: any;
//     address2: any;
//     city: any;
//     state: any;
//     zip: any;
//     country: any;
//     email: any;
//     phone1: any;
//     phone2: any;
//     fax: any;
//     contactName: any;
//     loadedMiles: number;
//     notes: string;
// }

// export class PackingSlip extends BaseIntEntity {
//     packingSlipNumber: number;
//     deliveryMethod: any;
//     note: any;
//     createdById: number;
//     createDate: Date;
//     invoiceNumber: number;
//     freight: number;
//     total: number;
//     quickBooksId: any;
//     quickBooksLastExport: Date;
//     readyToExport: Date;
//     dealer: Dealer;
//     dealerId: number;
//     orderLineDetails: OrderLineDetail[];
//     emailed: Date;
//     markedReadyById: number;
//     deleted: Date;
//     deletedBy: string;

//     get totalCalc() {
//         let subTotal = 0;
//         if (!!this.orderLineDetails) {
//             this.orderLineDetails.forEach((detail) => {
//                 if (!detail.deleted && !detail.orderLine.deleted) subTotal += detail.quantity * detail.orderLine.price;
//             });
//         }
//         return subTotal + this.freight;
//     }

//     get ordersList() {
//         const orderList = [];
//         if (!!this.orderLineDetails && this.orderLineDetails.length > 0) {
//             this.orderLineDetails.forEach((detail) => {
//                 if (!_.includes(orderList, detail.orderLine.order.invoiceNumber)) orderList.push(detail.orderLine.order.invoiceNumber);
//             });
//         }
//         return orderList;
//     }

//     get orderIdsList() {
//         const list = [];
//         if (!!this.orderLineDetails && this.orderLineDetails.length > 0) {
//             this.orderLineDetails.forEach((detail) => {
//                 if (!_.includes(list, detail.orderLine.orderId)) list.push(detail.orderLine.orderId);
//             });
//         }
//         return list;
//     }

//     get statusDisplay() {
//         let status = '';
//         const statusList = [];
//         if (!!this.orderLineDetails && this.orderLineDetails.length > 0) {
//             this.orderLineDetails.forEach((detail) => {
//                 if (!_.includes(statusList, detail.status.name)) statusList.push(detail.status.name);
//             });
//             statusList.forEach((statusName) => {
//                 status += statusName + '; ';
//             });
//         }
//         return status;
//     }

//     get canExport() {
//         let allComplete = true;
//         if (!this.orderLineDetails || this.orderLineDetails.length === 0) return false;
//         this.orderLineDetails.forEach((detail) => {
//             if (detail.status.name !== 'Complete') allComplete = false;
//         });
//         return allComplete;
//     }
// }

// export class Vendor extends BaseIntEntity {
//     companyName: string;
//     contactName: string;
//     accountNumber: string;
//     address1: string;
//     address2: string;
//     address3: string;
//     city: string;
//     state: string;
//     postalCode: string;
//     country: string;
//     phone: string;
//     fax: string;
//     email: string;
//     remitAddress1: string;
//     remitAddress2: string;
//     remitAddress3: string;
//     remitCity: string;
//     remitState: string;
//     remitPostalCode: string;
//     remitPhone: string;
//     remitEmail: string;
// }

// export class PurchaseOrder extends BaseIntEntity {
//     static Statuses = {
//         New: 1,
//         Ordered: 2,
//         Receiving: 3,
//         Complete: 4,
//         Void: 5,
//     };
//     pONumber: number;
//     pODate: Date;
//     completedTimestamp: Date;
//     vendorId: number;
//     vendor: Vendor;
//     statusId: number;
//     status: PurchaseOrderStatus;

//     shipToId: number;
//     shipCompanyName: any;
//     shipContactName: any;
//     shipToLocation: any;
//     shipToAddress1: any;
//     shipToAddress2: any;
//     shipToCity: any;
//     shipToState: any;
//     shipToZip: any;
//     shipToCountry: any;
//     shipToPhone: any;
//     shippingNote: any;
//     shipCarrier: any;
//     terms: any;
//     freight: number;
//     tax: number;
//     total: number;
//     balance: number;
//     note: any;
//     createdById: number;
//     createDate: Date;
//     deletedById: number;
//     deleted: Date;
//     quickBooksId: any;
//     quickBooksLastExport: Date;
//     emailed: Date;

//     lines: PurchaseOrderLine[];

//     static getNextLineNumber(lines: any[]) {
//         if (lines.length === 0) return 1;

//         let lineNumber: any;
//         lineNumber = _.maxBy(lines, 'lineNumber').lineNumber + 1;
//         return lineNumber;
//     }

//     getNextLineNumber() {
//         return PurchaseOrder.getNextLineNumber(this.lines);
//     }

//     get vendorAddressDisplay() {
//         if (!this.vendor) return null;
//         else
//             return `${this.vendor.address1}${this.vendor.address2 ? ' ' + this.vendor.address2 + ' ' : ''} ${this.vendor.city}, ${this.vendor.state} ${this.vendor.postalCode}${
//                 this.vendor.country ? '  ' + this.vendor.country : ''
//             }`;
//     }

//     get shippingAddressDisplay() {
//         return `${!!this.shipToLocation ? this.shipToLocation + ' - ' : ''}${this.shipToAddress1}${this.shipToAddress2 ? ' ' + this.shipToAddress2 + ' ' : ''} ${
//             this.shipToCity
//         }, ${this.shipToState} ${this.shipToZip}`;
//     }

//     get statusName() {
//         return this.status && this.status.name;
//     }

//     get subTotal() {
//         let subTotal = 0;
//         if (!!this.lines) {
//             this.lines.forEach((line) => {
//                 subTotal += line.quantity * line.cost;
//             });
//         }
//         return subTotal;
//     }
// }

// export class PurchaseOrderLine extends BaseIntEntity {
//     purchaseOrderId: number;
//     purchaseOrder: PurchaseOrder;
//     lineNumber: number;
//     partId: number;
//     part: Part;
//     partNumber: any;
//     description: any;
//     quantity: number;
//     quantityReceived: number;
//     quantityBackOrdered: number;
//     cost: number;
//     price: number;
//     note: any;
//     statusId: number;
//     status: PurchaseOrderLineStatus;

//     get lineTotal() {
//         return this.quantity * this.cost;
//     }
// }

// export class PurchaseOrderLineReceiving extends BaseIntEntity {
//     purchaseOrderLineId: number;
//     purchaseOrderLine: PurchaseOrderLine;
//     quantity: number;
//     created: Date;
//     deleted: Date;
//     createdById: number;
//     deletedById: number;
//     readyToExport: Date;
//     quickBooksId: string;
//     quickBooksLastExport: Date;

//     get lineTotal() {
//         return this.quantity * this.purchaseOrderLine.cost;
//     }

//     get readyToExportDisplay() {
//         return !!this.readyToExport;
//     }
//     get exportedDisplay() {
//         return !!this.quickBooksId;
//     }

//     get vendorDisplay() {
//         return this.purchaseOrderLine.purchaseOrder.vendor.companyName ?? '';
//     }

//     get poNumberDisplay() {
//         return this.purchaseOrderLine.purchaseOrder.pONumber ?? '';
//     }
// }

// export class PurchaseOrderStatus extends BaseIntEntity {
//     name: any;
// }
// export class PurchaseOrderLineStatus extends BaseIntEntity {
//     name: any;
// }

// export class EmailAddress extends BaseIntEntity {
//     name: any;
//     email: any;
//     created: Date;
//     deleted: Date;
// }

// export class EmailMessage extends BaseIntEntity {
//     invoice: PackingSlip;
//     invoiceId: number;
//     salesOrderId: number;
//     salesOrder: Order;
//     purchaseOrderId: number;
//     to: string;
//     subject: string;
//     body: string;
//     created: Date;
//     createdById: number;
//     cc: string;
//     bcc: string;

//     get type() {
//         return this.invoiceId
//             ? 'Invoice'
//             : this.salesOrderId && this.salesOrder.type === Order.Types.SalesOrder
//             ? 'SalesOrder'
//             : this.salesOrderId && this.salesOrder.type === Order.Types.Warranty
//             ? 'Warranty'
//             : 'PurchaseOrder';
//     }
// }

// export class AuditLog extends BaseIntEntity {
//     when: Date;
//     action: string;
//     entityTypeName: string;
//     primaryKey: string;
//     userName: string;
//     data: string;
// }

// export class AssemblySchedule extends BaseIntEntity {
//     orderLineDetailId: number;
//     orderLineDetail: OrderLineDetail;
//     jigId: number;
//     jig: AssemblyJig;
//     buildDate: Date;
//     created: Date;
//     createdBy: string;
//     completed: Date;
//     completedBy: string;

//     get displayName() {
//         if (this.orderLineDetail && this.orderLineDetail.orderLine && this.orderLineDetail.orderLine.order && this.orderLineDetail.orderLine.order.dealer) {
//             return `${this.orderLineDetail.vIN} --- ${this.orderLineDetail.orderLine.partNumber} - ${this.orderLineDetail.orderLine.order.dealer.companyName}`;
//         } else return '';
//     }
// }

// export class AssemblyJig extends BaseIntEntity {
//     name: string;
//     displayOrder: number;
// }

// export class Setting extends BaseIntEntity {
//     name: string;
//     intValue: number;
//     stringValue: string;
//     decimalValue: number;
// }

// export class SalesRep extends BaseEntity {
//     name: string;
//     displayName: string;
//     displayOrder: number;
//     email: string;
//     sendSalesOrders: boolean;
//     created: Date;
//     deleted: Date;

//     dealers: Dealer[];
// }

// export class ConfirmationType extends BaseIntEntity {
//     name: string;
//     displayOrder: number;
//     deleted: Date;
// }

// export class Confirmation extends BaseIntEntity {
//     code: Guid;
//     typeId: number;
//     type: ConfirmationType;
//     dealerId: number;
//     orderId: number;
//     message: string;
//     message2: string;
//     approved: Date;
//     declined: Date;
//     viewed: Date;
//     notes: string;
//     created: Date;
//     createdBy: string;
//     deleted: Date;
//     confirmedBy: string;
//     acknowledged: Date;
//     acknowledgedBy: string;
//     requestedSalesRepContact: boolean;
//     cancelReason: string;
//     remoteIPAddress: string;
//     messageName: string;
//     salesRepConfirmation: boolean;
// }

// export class ConfirmationMessage extends BaseIntEntity {
//     name: string;
//     message: string;
//     message2: string;
//     created: Date;
//     createdBy: string;
//     deleted: Date;
// }

// export class ConfirmationPaymentMethod extends BaseIntEntity {
//     name: string;
//     displayOrder: string;
//     deleted: Date;
// }
